import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'
import resolveScopedStyles from '../../utils/resolveScopedStyles'
import { styleGuideClasses } from './config'

const StyledText = ({
  el,
  children,
  className,
  additionalClassName,
  style,
}) => {
  const Element = el
  const css = styles[className]
  const scoped = resolveScopedStyles(
    <scope><style jsx>{css}</style></scope>
  )

  const classes = [scoped.className, className, additionalClassName].join(' ')

  return (
    <Element className={classes} style={style}>
      { children }
      { scoped.styles }
    </Element>
  )
}

StyledText.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  el: PropTypes.string,
  additionalClassName: PropTypes.string,
  className: PropTypes.oneOf(styleGuideClasses),
  style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
}

StyledText.defaultProps = {
  el: 'p',
  className: 'p1',
  additionalClassName: '',
  style: {},
}

export default StyledText
